<template>
    <div id="quote-form">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                {
                    text: 'Quote',
                    to: { path: '/quote' },
                },
                { text: !$route.query.id ? 'Tambah Quote' : 'Ubah Quote' },
            ]"
            divider=">"
        ></v-breadcrumbs>

        <h3 class="header-text font-weight-bold">
            {{ !$route.query.id ? "Tambah Quote" : "Ubah Quote" }}
        </h3>

        <v-card plain class="pa-4">
            <v-list-item two-line class="pa-0">
                <v-list-item-content class="pa-0">
                    <v-list-item-title class="font-weight-bold pb-2">
                        Quotes
                    </v-list-item-title>
                    <v-textarea
                        ref="quote"
                        counter
                        placeholder="Quote"
                        v-model="form.quote"
                        :rules="rules"
                        outlined
                    />
                </v-list-item-content>
            </v-list-item>
            <v-list-item two-line class="pa-0">
                <v-list-item-content class="pa-0">
                    <v-list-item-title class="font-weight-bold pb-2">
                        Level
                    </v-list-item-title>
                    <v-select
                        outlined
                        placeholder="Pilih Level"
                        v-model="form.level_id"
                        class="pa-0"
                        :items="levelList"
                        item-text="level_name"
                        item-value="level_id"
                    >
                        <template v-slot:selection="{ item }">
                            <v-list-item class="pa-0 ma-0">
                                <v-list-item-title>{{
                                    item.level_name
                                }}</v-list-item-title>
                            </v-list-item>
                        </template>
                        <template v-slot:item="{ item }">
                            <v-list-item-title>{{
                                item.level_name
                            }}</v-list-item-title>
                        </template>
                    </v-select>
                </v-list-item-content>
            </v-list-item>
            <v-card-actions class="pa-4">
                <v-spacer></v-spacer>
                <v-btn
                    depressed
                    class="px-6 py-2 white--text"
                    color="blew"
                    @click="save()"
                >
                    Simpan</v-btn
                >
            </v-card-actions>
        </v-card>

        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import AmbisMeterService from "@/modules/ambis_meter/services/ambis_meter.js";
import Spinner from "@/modules/global/components/plugins/Spinner";

export default {
    name: "ambis-meter-form",

    components: {
        "app-spinner": Spinner,
    },

    data: function () {
        return {
            isLoading: false,
            rules: [(v) => v.length <= 255 || "Maksimal 255 karakter"],
            form: {
                id: this.$route.query.id,
                quote: "",
                level_id: 0,
            },
            levelList: [
                {
                    level_id: 1,
                    level_name: "Bronze",
                },
                {
                    level_id: 2,
                    level_name: "Silver",
                },
                {
                    level_id: 3,
                    level_name: "Gold",
                },
                {
                    level_id: 4,
                    level_name: "Beginner",
                },
                {
                    level_id: 5,
                    level_name: "No Rank",
                },
            ],
        };
    },

    mounted: function () {
        // this.getListLevel();
        if (this.$route.query.id) {
            this.form = this.$store.state.quote;
        }
    },

    methods: {
        async getListLevel() {
            const context = this;
            context.isLoading = true;
            await AmbisMeterService.getQuotesDetail(function (response) {
                if (response.success) {
                    context.levelList = response.data;
                }
                context.isLoading = false;
            });
        },

        validateForm() {
            var err = false;
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
            if (
                this.form.quote == "" ||
                this.form.quote == " " ||
                !this.form.quote
            ) {
                this.$store.commit("showAlert", {
                    message: "Quote wajib diisi!",
                    type: "error",
                });
                err = true;
            } else if (!this.form.level_id) {
                this.$store.commit("showAlert", {
                    message: "Level wajib diisi!",
                    type: "error",
                });
                err = true;
            } else if (!this.$refs.quote.validate()) {
                this.$store.commit("showAlert", {
                    message: "Quote melebihi maksimal karakter!",
                    type: "error",
                });
                err = true;
            }
            return !err;
        },

        save() {
            var context = this;
            if (this.validateForm()) {
                if (this.$route.query.id) {
                    AmbisMeterService.updateQuotes(
                        this.$route.query.id,
                        context.form,
                        function (response) {
                            if (response.success) {
                                if (response.data.status === "500") {
                                    context.$store.commit("showAlert", {
                                        message: `Gagal mengubah Quote!`,
                                        type: "error",
                                    });
                                } else {
                                    context.$store.commit("showAlert", {
                                        message: `Berhasil mengubah data!`,
                                        type: "success",
                                    });
                                    context.$store.commit(
                                        "quote_init",
                                        context.form,
                                    );
                                    context.$router.push("/quote");
                                }
                            } else {
                                context.$store.commit("showAlert", {
                                    message: `Gagal mengubah Quote`,
                                    type: "error",
                                });
                            }
                            context.isLoading = false;
                        },
                    );
                } else {
                    AmbisMeterService.addQuotes(
                        context.form,
                        function (response) {
                            if (response.success) {
                                context.$store.commit("showAlert", {
                                    message: `Berhasil menyimpan data!`,
                                    type: "success",
                                });
                                context.$store.commit(
                                    "quote_init",
                                    context.form,
                                );
                                context.$router.push("/quote");
                            } else {
                                context.$store.commit("showAlert", {
                                    message: `Gagal menyimpan!`,
                                    type: "error",
                                });
                            }
                            context.isLoading = false;
                        },
                    );
                }
            } else {
                this.isLoading = false;
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// QuoteForm.vue?2ecd3daf